import { render, staticRenderFns } from "./BankIntegral.vue?vue&type=template&id=94f87b50&scoped=true"
import script from "./BankIntegral.vue?vue&type=script&lang=js"
export * from "./BankIntegral.vue?vue&type=script&lang=js"
import style0 from "./BankIntegral.vue?vue&type=style&index=0&id=94f87b50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f87b50",
  null
  
)

export default component.exports